import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import userEvent from "@testing-library/user-event";

const useStyles = makeStyles((theme) => ({
  color: {
    color: theme.grey,
  },
  formHelperText: {
    fontSize: 10,
    paddingLeft: 6,
  },
}));

export const ManagerLookup = (props) => {
  const { onChangeFunction, errorMessage, email, disabled, mgrId } = props;
  console.log("hello",props)
  const { t } = useTranslation();
  const classes = useStyles();
  let managerEmailOptions;
  let selectedIndex;
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state => state.user.auth))

  if (appConfig && appConfig.managerEmails !== null) {
     let selectedManagerCountry = appConfig.managerEmails.filter(item=>item.managerId===mgrId)
     managerEmailOptions= appConfig.managerEmails.filter(item=>item?.managerCountry===selectedManagerCountry[0]?.managerCountry)
    if (mgrId) {
      selectedIndex = managerEmailOptions.findIndex((option) => {
        return option.managerId === mgrId;
      });
      console.log("hello, selected Man",selectedManagerCountry)
      console.log("hello, selected index",selectedIndex)
    }
  }

  return (
    <>
      { managerEmailOptions &&
        <Autocomplete
          options={managerEmailOptions}
          // getOptionLabel= {(option) => option.managerEmail}
          getOptionLabel={(option) =>
            option && option.managerFirstName
              ? `${option.managerFirstName} ${option.managerLastName} (${option.managerId})`
              : ""
          }
          id="manager"
          classes={{ inputRoot: classes.color }}
          defaultValue={managerEmailOptions[selectedIndex]}
          disabled={disabled}
          onBlur={onChangeFunction}
          onChange={onChangeFunction}
          InputProps={{ className: classes.color }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              error={!!errorMessage.manager}
              helperText={errorMessage.manager}
              label={t("pgAddWorker.lblManagerLookup")}
              FormHelperTextProps={{
                className: classes.formHelperText,
              }}
            />
          )}
        />
      }
    </>
  );
};

ManagerLookup.propTypes = {
  onChangeFunction: PropTypes.func.isRequired,
  errorMessage: PropTypes.object.isRequired,
  email: PropTypes.string,
  disabled: PropTypes.bool
};

export default ManagerLookup;
